/**
 * v3.15-1104 — CF360 State Badge
 *
 * Small pill rendered next to a client's name (in lists, headers, and
 * search results) whenever `cf360_state` is set. Three visual states:
 *
 *   - in_cf360  → amber "In CF360" pill
 *   - returned  → slate "CF360 History" pill (subtle)
 *   - null      → renders nothing
 *
 * Per JOINT_IMPLEMENTATION_PLAN §2.3.
 */
import { ShieldAlert, CheckCircle2 } from 'lucide-react';

export const CF360StateBadge = ({ state, sentAt = null, compact = false }) => {
  if (state !== 'in_cf360' && state !== 'returned') return null;

  if (state === 'in_cf360') {
    return (
      <span
        data-testid="cf360-state-badge-in-cf360"
        title={sentAt ? `In CF360 since ${sentAt}` : 'Currently in CF360'}
        className="inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-900 border border-amber-300 px-2 py-0.5 text-[10px] font-semibold leading-none"
      >
        <ShieldAlert className="h-3 w-3" />
        {compact ? 'CF360' : 'In CF360'}
      </span>
    );
  }
  return (
    <span
      data-testid="cf360-state-badge-returned"
      title="Has prior CF360 history"
      className="inline-flex items-center gap-1 rounded-full bg-slate-100 text-slate-700 border border-slate-300 px-2 py-0.5 text-[10px] font-medium leading-none"
    >
      <CheckCircle2 className="h-3 w-3" />
      {compact ? 'CF360 ✓' : 'CF360 History'}
    </span>
  );
};

export default CF360StateBadge;
